import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Switch, Route } from 'react-router-dom'

// Components
import OrderSearch from './OrderSearch'
import Order from './Order'

// State
import { addRoute } from '../../../store/actions/route'

class AdminOrders extends Component {
    constructor(props){
        super(props)
        this.props.addRoute(this.props.match)
    }

    render() {
        return (
            <div>
                <h1>View Orders</h1>

                <Switch>
                    <Route path={'/admin/view-orders'} exact component={OrderSearch} />
                    <Route path={'/admin/view-orders/:id'} component={Order} />
                </Switch>
            </div>
        )
    }
}

export default connect(null, { addRoute })(AdminOrders)



// WEBPACK FOOTER //
// ./src/components/admin/orders/AdminOrders.js